import { Injectable, Output, EventEmitter } from '@angular/core';
import { DropdownCloseGroupEvent } from './dropdown-close-group-event.interface';
@Injectable({ providedIn: 'root' })
export class DropdownService {
	@Output() readonly closeDropDownEvent: EventEmitter<string> =
		new EventEmitter<string>();
	@Output() readonly openDropDownEvent: EventEmitter<string> =
		new EventEmitter<string>();
	@Output()
	readonly closeOthersInGroupEvent: EventEmitter<DropdownCloseGroupEvent> =
		new EventEmitter<DropdownCloseGroupEvent>();
	@Output() readonly closeGroupEvent: EventEmitter<DropdownCloseGroupEvent> =
		new EventEmitter<DropdownCloseGroupEvent>();

	open(dropdownId: string): void {
		this.openDropDownEvent.emit(dropdownId);
	}

	close(dropdownId: string): void {
		this.closeDropDownEvent.emit(dropdownId);
	}

	closeOtherDropdownsInGroup(dropdownId: string, dropdownGroup: string): void {
		this.closeOthersInGroupEvent.emit({ dropdownId, dropdownGroup });
	}

	closeGroup(dropdownGroup: string): void {
		this.closeGroupEvent.emit({ dropdownGroup });
	}
}
